module.exports = __webpack_public_path__ + "img/tarot-major-arcana-00.4c57b1bb.png";